// extracted by mini-css-extract-plugin
module.exports = {"NavBarColor":"StaticStyle_NavBarColor__3XBAh","SecundaryStrings":"StaticStyle_SecundaryStrings__2q5xX"};